import { MsgService } from './../msg/msg.service';
import { UtilCalcTime } from './utilCalcTime';
import * as MSG from '../../share/msg/msg';

/** Smile9固有の共通メソッドをまとめるクラス */
export class UtilSmile9 {
  /** 価格を文字列に変換: Smile9-APIのMoneyServiceと同様の処理 */
  convertPriceToString(price: number, yen_disp_type: number) {
    if (price === null || price === undefined) {
      return;
    }

    let str = '';
    str += price.toLocaleString();  // カンマ区切りの数字文字列に変換
    switch (yen_disp_type) {
      case 0:
        str = '¥' + str;
        break;
      case 1:
        str += '円';
        break;
    }
    return str;
  }

  /** 単価配列から現在時刻に適用される単価を決定 */
  decideValidTankaInfo(tankaArray: IUtilSmile9.MenuTanka[], dbCurrentTime: Date, yen_disp_type: number): string {
    const uTime = new UtilCalcTime();
    // 単価配列をtanka_start_dateの降順に並び替え
    tankaArray = tankaArray.sort((x, y) => uTime.toDate(x.tanka_start_date, '/').getTime() - uTime.toDate(y.tanka_start_date, '/').getTime());
    // 単価適用開始日付がDB現在時刻以降かつ総務確認区分=1の単価情報を取得
    const validTanka = tankaArray.find(t => {
      if (uTime.toDate(t.tanka_start_date, '/') >= dbCurrentTime && t.ga_confirmed === 1) {
        return true;
      }
      return false;
    });
    if (!validTanka) {
      return null;
    }

    return this.convertPriceToString(validTanka.emp_cost, yen_disp_type);
  }

  /** スキャンしたIdm or UID の文字数を検証。 */
  checkFelicaIdLength(felicaId: string): boolean {
    console.log('scan => ', felicaId);
    // 8桁mifere対応のため無効化。今後スキャン直後処理が必要になった際の為、メソッドは残す

    // Felica Idm = 16桁, Mifere UID = 14桁なので、14桁より小さい文字列は空白文字に変換
    // if (felicaId.length < 14) {
    //   return false;
    // }
    return true;
  }

  /** usernameの文字列検証。
   * @param {string} value 入力値
   * @param {MsgService} msgServ utilSmile9クラスでは生成できないので各ComponentのServiceインスタンスを引数で受ける
   * @param {boolean} warnByToaster 不正な値の場合にトースターで警告をするか
   * @param {boolean} removeInvalidValue 不正な値の場合にその値のみ取り除くか
   * @returns {string} 検証後文字列。不正な値は自動的に取り除く
   */
  public validateUsernameStyle(value: string, removeInvalidValue = true, warnByToaster = false, msgServ: MsgService = null): string {
    // 空白文字を含むか
    const regexpHasBlank = /\s+/g;
    value = this.validate(regexpHasBlank, value, warnByToaster, '空白文字は入力できません。', removeInvalidValue, msgServ);

    // 全角文字を含むか
    const regexpHasFullWidthChar = /[^\x00-\x7Eｧ-ﾝﾞﾟ]+/g;
    value = this.validate(regexpHasFullWidthChar, value, warnByToaster, '全角文字は入力できません。', removeInvalidValue, msgServ);

    return value;
  }

  /** Smile9IDの文字列検証。
   * @param {string} value 入力値
   * @param {MsgService} msgServ utilSmile9クラスでは生成できないので各ComponentのServiceインスタンスを引数で受ける
   * @param {boolean} warnByToaster 不正な値の場合にトースターで警告をするか
   * @param {boolean} removeInvalidValue 不正な値の場合にその値のみ取り除くか
   * @returns {string} 検証後文字列。不正な値は自動的に取り除く
   */
  public validateSmile9IdStyle(value: string, removeInvalidValue = true, warnByToaster = false, msgServ: MsgService = null): string {
    // 全角文字を含むか
    const regexpHasFullWidthChar = /[^\x00-\x7Eｧ-ﾝﾞﾟ]+/g;
    value = this.validate(regexpHasFullWidthChar, value, warnByToaster, '全角文字は入力できません。', removeInvalidValue, msgServ);

    return value;
  }

  private validate(regexp: RegExp, value: string, warnByToaster: boolean, warnMessage: string, removeInvalidValue: boolean, msgServ: MsgService): string {
    if (value.match(regexp)) {
      if (warnByToaster) {
        msgServ.warning(warnMessage, '');
      }
      if (removeInvalidValue) {
        value = value.replace(regexp, '');
      }
    }
    return value;
  }

  /** いただきます端末のログ用のリクエストIDをフロントで生成 */
  public static createAngularRequestId: (username: string) => string = (username) => {
    const today = new Date();
    const yyyyMMddHHmmssfff: string = today.getFullYear() +
                            ('0' + (today.getMonth() + 1)).slice(-2) +
                            ('0' + today.getDate()).slice(-2) +
                            ('0' + today.getHours()).slice(-2) +
                            ('0' + today.getMinutes()).slice(-2) +
                            ('0' + today.getMilliseconds()).slice(-3);
    return `${username}-${yyyyMMddHHmmssfff}`;
  }

  /** 予約IDを生成 */
  public static getRsvId = (
    ug_id_user: string
    , cafe_code: number
    , rsv_date: string
    , open_code: number
    , username: string
    , rsv_status: number
    , menu_id: string) => {
      return `${ug_id_user}-${cafe_code}-${rsv_date}-${open_code}-${username}-${rsv_status}-${menu_id}`;
  }

  /** 親子共通IDを生成 */
  public static getParentChildId = (
    ug_id_user: string
    , cafe_code: number
    , rsv_date: string
    , open_code: number
    , username: string
    , menu_type_code: number
    , emp_code: number
    , menu_id: string) => {
      return `${ug_id_user}-${cafe_code}-${rsv_date}-${open_code}-${username}-${menu_type_code}-${emp_code}-${menu_id}`;
  }
}

export namespace IUtilSmile9 {
  export interface MenuTanka {
    sei_kbn: number;
    tanka_start_date: string;
    menu_tanka: number;
    emp_cost: number;
    co_cost: number;
    ga_confirmed: number;
  }
}
